import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import StandardTextField from 'Common/Components/StandardTextField/index';
import Button from 'shared/ui/Button';
import { CUSTOM_ATTRIBUTE_TYPES } from 'Screens/Contextualization/Manage/components/CustomAttributesModal/constants';
import { Wrapper, Buttons, Content, Container } from './styled';
import './styled.css';

const hasValue = (value) => String(value ?? '').trim().length > 0;
const getInputValue = (value) => value === null || typeof value === 'undefined' ? '' : String(value);

const IntegerCustomField = ({
  field, onCancel, onSave, vuln, initialValue
}) => {
  const [value, setValue] = useState(getInputValue(initialValue));
  const isFloatField = field.field_type === CUSTOM_ATTRIBUTE_TYPES.FLOAT;
  const [editMode, setEditMode] = useState(!hasValue(initialValue));
  useEffect(() => {
    const nextValue = getInputValue(initialValue);
    if (value !== nextValue) {
      setValue(nextValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = () => {
    onSave(vuln, field.field_name, value);
    setEditMode(false);
    if (!hasValue(value)) onCancel();
  };
  const handleCancel = () => {
    setEditMode(false);
    if (hasValue(initialValue)) {
      setValue(getInputValue(initialValue));
    } else {
      onCancel();
    }
  };

  const hasNonNumericValues = () => {
    const pattern = isFloatField ? /^\d+(\.\d{1,2})?$/ : /^\d+$/;
    const currentValue = String(value ?? '');
    return currentValue.length > 0 && !pattern.test(currentValue);
  };

  const error = hasNonNumericValues();
  const errorMessage = isFloatField ? 'Use numbers only, with up to 2 decimal places' : 'Use numbers only';

  return (
    <Wrapper>
      <Container>
        {editMode
          ? (
            <StandardTextField
              className='autoHeightText'
              name="custom_field_name"
              value={ value }
              error={ error }
              errorMessage={ errorMessage }
              onChange={ setValue }
              type="number"
              step={ isFloatField ? 0.01 : 1 }
            />
            )
          : <Content onClick={ () => setEditMode(true) }>{initialValue}</Content> }
      </Container>
      {editMode &&
      (
      <Buttons>
        <Button variant="secondary" onClick={ handleCancel }>Cancel</Button>
        <Button disabled={ error } onClick={ handleSave }>Save</Button>
      </Buttons>
      )}
    </Wrapper>
  );
};

IntegerCustomField.defaultProps = {
  initialValue: null
};

IntegerCustomField.propTypes = {
  field: PropTypes.shape({
    field_display_name: PropTypes.string,
    field_type: PropTypes.oneOf([CUSTOM_ATTRIBUTE_TYPES.INTEGER, CUSTOM_ATTRIBUTE_TYPES.FLOAT])
  }).isRequired,
  vuln: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  initialValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IntegerCustomField;
